import type { NarouTocItem, NarouTocItemOrChapter } from './types';
import { parseEpisodeUrl } from './url';

const NAVIGATION_LABEL_RE =
  /^(?:次へ|前へ|最後へ|目次|トップ|もっと読む|戻る|あらすじ|しおり|ブックマーク)$/i;

function pushEpisodeFromLink(
  a: Element,
  targetUrl: string,
  tocItems: NarouTocItemOrChapter[],
  episodes: NarouTocItem[],
  seen: Set<string>,
): void {
  const href = a.getAttribute('href') || '';
  const text = a.textContent?.replace(/\s+/g, ' ').trim() || '';
  if (!href || !text || NAVIGATION_LABEL_RE.test(text)) {
    return;
  }

  const parsed = parseEpisodeUrl(href, targetUrl);
  if (!parsed) {
    return;
  }

  const key = `${parsed.ncode}:${parsed.episodeNumber}`;
  if (seen.has(key)) {
    return;
  }

  seen.add(key);
  const item = {
    episodeNumber: parsed.episodeNumber,
    url: parsed.url,
    title: text,
  };
  episodes.push(item);
  tocItems.push({ type: 'episode', ...item });
}

export function parseTocFromDoc(
  doc: Document,
  targetUrl: string,
  tocItems: NarouTocItemOrChapter[],
  episodes: NarouTocItem[],
  seen: Set<string>,
): void {
  const container = doc.querySelector('.p-eplist, .index_box');
  if (container) {
    const targets = container.querySelectorAll(
      '.p-eplist__chapter-title, .p-eplist__sublist, .chapter_title, dl.novel_sublist2, .subtitle',
    );
    for (const el of targets) {
      if (
        el.classList.contains('p-eplist__chapter-title') ||
        el.classList.contains('chapter_title')
      ) {
        const titleText = el.textContent?.trim() || '';
        if (titleText) {
          tocItems.push({ type: 'chapter', title: titleText });
        }
        continue;
      }

      const a = el.querySelector('a');
      if (a) {
        pushEpisodeFromLink(a, targetUrl, tocItems, episodes, seen);
      }
    }
  }

  if (episodes.length === 0) {
    for (const a of doc.querySelectorAll('a[href]')) {
      pushEpisodeFromLink(a, targetUrl, tocItems, episodes, seen);
    }
  }
}

export function extractMaxPage(doc: Document): number {
  let maxPage = 1;
  for (const a of doc.querySelectorAll('a')) {
    const href = a.getAttribute('href') || '';
    const match = href.match(/\?p=(\d+)/);
    if (match) {
      const pageNum = Number.parseInt(match[1], 10);
      if (pageNum > maxPage) {
        maxPage = pageNum;
      }
    }
  }
  return maxPage;
}
